import styled from 'styled-components/macro';
import theme from '../../../../constants/theme';
import { btnReset } from '../../../../helpers/style-helpers';
import HeaderSC from '../header/header.styled';

export interface IAuthPageSC {
  backgroundImage?: string;
  step?: number;
}

export const AuthPageSC = styled.div<IAuthPageSC>`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 50px 1fr 30px;
  grid-template-areas:
    '.'
    'content'
    '.';
  position: relative;
  padding: 16px;
  min-height: 100vh;

  background: url(${(props) => props.backgroundImage}) no-repeat;
  background-position: ${(props) => (props.step === 0 ? '70% 60%' : '50% 40%')};
  background-size: cover;

  padding-top: 0px;
  padding-bottom: 0px;

  .form-description {
    color: #333d6c;
    margin-bottom: 30px;
  }

  .hilbi-logo {
    display: none;
    position: absolute;
    top: 16px;
    left: 16px;
  }

  .submit-button {
    margin-top: 50px;
    margin-bottom: 20px;
    height: 50px;
  }

  .submit-button-code {
    margin-top: 0px;
    height: 50px;
  }

  .loader {
    grid-area: form;
    place-self: center;
  }
  /* 
  p {
    color: rgba(20, 27, 56, 0.4);
  } */

  .detailed-agreement {
    p {
      font-weight: bold;
      line-height: 1.4;
      font-size: 14px;
      color: ${theme.colors.fontLight};
    }

    a {
      color: ${theme.colors.primary};
      font-weight: 700;
    }
  }

  .auth-resend-link {
    cursor: pointer;
    font-size: 14px;
    color: #333d6c;
    font-weight: bold;
    text-transform: uppercase;
    text-decoration: underline;
    transition: 0.2s opacity;

    &:hover {
      opacity: 0.7;
    }
  }

  .auth-back-link {
    ${btnReset}

    margin-top: 24px;
    font-size: 14px;
    font-weight: 700;
    color: #333d6c;
    opacity: 0.5;

    &:hover {
      opacity: 0.4;
    }
  }

  .auth-reg-link,
  .auth-forgot-link {
    color: ${theme.colors.primary};
    font-weight: 600;
  }

  .auth-login-bottom {
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #333d6c;
  }

  .form {
    background: ${({ theme }) => theme.color.surface.baseline};
    border-radius: 24px;
    padding: 30px 16px;
  }

  .dev-btns {
    position: fixed;
    bottom: 10px;
    left: 10px;
  }

  .text {
    grid-area: text;
    font-size: 17px;
    line-height: 25px;
    color: #fff;
  }

  .form-wrapper {
    grid-area: content;
    display: grid;
    grid-template-columns: 70px 1fr;
    grid-template-rows: ${({ step }) => (step === 2 ? '90px auto' : '130px auto')};
    grid-template-areas:
      'header header'
      'form form';

    ${HeaderSC} {
      align-self: flex-start;
    }
  }

  .form-wrapper.login,
  .form-wrapper.forgotten {
    ${HeaderSC} {
      align-self: flex-end;
    }

    .form {
      grid-area: form;
      align-self: flex-start;
      margin-top: 60px;
    }

    @media (min-width: 900px) {
      .form {
        grid-area: right-content;
        place-self: center;
        width: 75%;
      }

      ${HeaderSC} {
        grid-row-start: 1;
        grid-row-end: 3;
        align-self: center;
        padding-bottom: 120px;
      }
    }
  }

  @media (min-width: 650px) {
    .form-wrapper {
      padding: 0 10%;
    }
  }

  @media (min-width: 900px) {
    grid-template-columns: 0.35fr 0.65fr 1fr;
    grid-template-rows: 0.1fr 1fr;
    grid-template-areas:
      '. . right-content'
      '. left-content right-content';
    padding-bottom: 60px;
    padding-top: 120px;

    .text {
      font-size: 20px;
      line-height: 30px;
    }

    .form-wrapper {
      display: contents;

      ${HeaderSC} {
        grid-area: left-content;
      }

      & .right-content {
        grid-area: right-content;
        align-self: center;
        justify-self: center;
        max-width: 65%;
      }
    }

    .form {
      padding: 40px;
    }

    .hilbi-logo {
      display: block;
    }
  }

  form {
    .ui-textfield {
      width: 100%;
    }
  }
`;
